import { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { usePDFOutlineContext } from '~/components/AssetModalV2/Content/Footer/contexts/PDFOutlineContext';
import { PDFPageControls } from '~/components/AssetModalV2/Visualizer/PDFVisualizer/PDFControls/components/PDFPageControls';
import { centralizedClipIsPDFTypeSelector } from '~/store/centralizedClip/selectors';

/**
 * Floating page paginator pill for the public mobile PDF layouts. Those layouts (AssetModalMobileLayout)
 * scroll, so a paginator placed in normal flow would fall below the fold; rendering it as an overlay
 * pinned over the visualizer keeps it visible. Private mobile renders the paginator inline in its pinned
 * nav-arrows bar instead. Renders nothing for non-PDF assets.
 */
export const MobilePDFPageControls = memo(() => {
  const { currentPage, numPages, changePage } = usePDFOutlineContext();
  const isPDF = useSelector(centralizedClipIsPDFTypeSelector);

  // No auto-hide behavior to toggle in this overlay, so focus changes are a no-op.
  const handleFocusChange = useCallback(() => {}, []);

  if (!isPDF || numPages === 0) {
    return null;
  }

  return (
    <div className="rounded-8 ads:bg-base bg-gray-1 px-2 py-1">
      <PDFPageControls
        currentPage={currentPage}
        totalPages={numPages}
        goToPage={changePage}
        onFocusChange={handleFocusChange}
      />
    </div>
  );
});

MobilePDFPageControls.displayName = 'MobilePDFPageControls';
